import React from 'react';
import './Partners.css';

const partners = [
  { name: 'Koç Schools', logo: '/images/kocSchools.jpg' },
  { name: 'Capitol', logo: '/images/Capitol.png' },
  { name: 'Renaissance Polat İstanbul Hotel', logo: '/images/polat.jpg' },
  { name: 'Kempinski Maçka Residences', logo: '/images/kempinski.jpg' },
  { name: 'Adler Pelzer Otomotiv', logo: '/images/adlerpelzer.png' },
  { name: 'Trendy Lara Hotel', logo: '/images/trendy.png' },
  { name: 'Faraero ve Farform Otoomotiv', logo: '/images/faraero.png' },
  { name: 'Akmerkez', logo: '/images/akmerkez.svg' },
];

function Partners() {
  return (
    <div className="partners-container">
      <h2 className="text-center mb-4">Our Partners</h2>
      <div className="row justify-content-center">
        {partners.map((partner, index) => (
          <div key={index} className="col-md-3 text-center partner-box">
            <img src={partner.logo} alt={partner.name} className="img-fluid partner-logo" />
            <h4 className="partner-name">{partner.name}</h4>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Partners;
